import React, { memo } from 'react';
import { Brain, Smartphone, XCircle } from 'lucide-react';
export function Problem() {
  return <section className="py-16 md:py-24 bg-navy-800/30 border-y border-steel-400/5" data-id="element-129">
      <div className="container mx-auto px-4" data-id="element-130">
        <div className="max-w-4xl mx-auto" data-id="element-131">
          <div className="text-center mb-16" data-id="element-132">
            <h2 className="text-3xl md:text-4xl mb-6" data-id="element-133">
              No es la edad.{' '}
              <span className="text-amber-400" data-id="element-134">Es saturación.</span>
            </h2>
            <p className="text-lg text-steel-300 max-w-2xl mx-auto" data-id="element-135">
              No es que estés perdiendo la memoria por la edad. Es que tu
              cerebro está saturado. El estrés crónico y las pantallas azules
              han bloqueado tu capacidad natural de "archivar" la información
              del día.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-136">
            <div className="glass-panel p-8" data-id="element-137">
              <div className="w-12 h-12 rounded-full bg-red-500/10 flex items-center justify-center mb-6" data-id="element-138">
                <Brain className="text-red-400" size={24} data-id="element-139" />
              </div>
              <h3 className="text-xl mb-4" data-id="element-140">El Efecto Cortisol</h3>
              <p className="text-steel-300 leading-relaxed" data-id="element-141">
                Cuando intentas forzar el recuerdo a las 11 PM, disparas
                cortisol, la hormona que literalmente disuelve la memoria a
                corto plazo. Te despiertas cansada, con esa sensación de "nube
                gris" en la frente y el temor constante de que tu agudeza mental
                se está escapando.
              </p>
            </div>

            <div className="glass-panel p-8" data-id="element-142">
              <h3 className="text-xl mb-6 flex items-center gap-3" data-id="element-143">
                <XCircle className="text-amber-500" size={24} data-id="element-144" />
                Por qué lo que intentaste falló
              </h3>
              <ul className="space-y-4" data-id="element-145">
                <li className="flex gap-3" data-id="element-146">
                  <Smartphone className="text-steel-400 shrink-0 mt-1" size={20} data-id="element-147" />
                  <p className="text-steel-300" data-id="element-148">
                    <strong className="text-steel-200" data-id="element-149">
                      Las listas en el celular
                    </strong>{' '}
                    mantienen tu cerebro en estado de alerta visual, impidiendo
                    el sueño profundo.
                  </p>
                </li>
                <li className="flex gap-3" data-id="element-150">
                  <Brain className="text-steel-400 shrink-0 mt-1" size={20} data-id="element-151" />
                  <p className="text-steel-300" data-id="element-152">
                    <strong className="text-steel-200" data-id="element-153">
                      Repasar mentalmente
                    </strong>{' '}
                    los pendientes consume la energía que tu hipocampo necesita
                    para consolidar recuerdos.
                  </p>
                </li>
                <li className="flex gap-3" data-id="element-154">
                  <XCircle className="text-steel-400 shrink-0 mt-1" size={20} data-id="element-155" />
                  <p className="text-steel-300" data-id="element-156">
                    <strong className="text-steel-200" data-id="element-157">
                      Aceptar que "es la edad"
                    </strong>{' '}
                    es un mito que te impide activar los mecanismos de
                    neuro-recuperación que aún posees.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}